module.exports = __webpack_public_path__ + "/src/app/views/NexioPayment/transaction_history.html";